export default {
  me: {
    __typename: 'MeMutation',
    dietSetReplaceProduct: {
      code: 200,
      __typename: 'BasicMutationSuccess',
    },
  },
};
